import baseApi from "./base"
import { ApplyRequest } from "./types/apply"
import { BaseResponse } from "./types/common"
import { GetCaptchaResponse, GetCaptchaRequest } from "./types/captcha"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn: body,
          functionCode: "SPE0020",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptchaResponse, GetCaptchaRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          guid : body.guid,
          TokenSessionId : body.TokenSessionId,
          functionCode: "SPE0020",
          NextTransactionUrl: "Facebook/ExpatBankingLead/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptchaResponse, GetCaptchaRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          functionCode: "SPE0020",
          NextTransactionUrl: "Facebook/ExpatBankingLead/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<BaseResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          adSoyad: body.adSoyad,
          eposta : body.email,
          captcha: body.captcha,
          telefon: body.telefon,
          kvkk: body.kvkk,
          etk:body.etk,
          cid:body.cid,
          functionCode: "SPE0020",
          NextTransactionUrl: "Facebook/ExpatBankingLead/Apply1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation } = api

export default api
